module.exports = __webpack_public_path__ + "img/mfw.701fa378.png";